module.exports = __webpack_public_path__ + "img/secretary_firm.bb3c7e44.svg";